<div
    [ngClass]="{
        'datiq-graph-card-chart--positive': isPositive,
        'datiq-graph-card-chart--negative': isNegative
    }"
    class="datiq-graph-card-chart"
>
    <div class="datiq-graph-card-chart__container--line">
        <datiq-graph [settings]="graph"></datiq-graph>
    </div>
    <ng-container *ngIf="settings?.labelType !== ''">
        <div
            [ngStyle]="{ color: textColor }"
            class="datiq-graph-card-chart__value"
        >
            <mat-icon [svgIcon]="labelIcon"></mat-icon>
            <span class="datiq-graph-card-chart__value__label">{{
                label
            }}</span>
        </div>
    </ng-container>
</div>
